import React, { useState } from "react";
import "./MedicationForm.scss";

const MedicationForm = ({ initialData, modelos = [], onSave, onClose }) => {
  const [formData, setFormData] = useState({
    id: null,
    nome: "",
    descricao: "",
    dosagem: "",
    frequencia: "",
    linha: initialData?.linha || 0,
    coluna: initialData?.coluna || 0
  });
  const [modeloSelecionado, setModeloSelecionado] = useState(null);
  const [filtro, setFiltro] = useState("");
  const [categoriaFiltro, setCategoriaFiltro] = useState("");

  const handleSubmit = () => {
    if (!modeloSelecionado) {
      alert("Por favor, selecione um modelo de medicamento.");
      return;
    }
    
    onSave({
      ...formData,
      nome: modeloSelecionado.nome,
      descricao: modeloSelecionado.descricao || "",
      dosagem: modeloSelecionado.dosagem,
      frequencia: modeloSelecionado.frequencia,
      fabricante: modeloSelecionado.fabricante,
      viaAdministracao: modeloSelecionado.viaAdministracao,
      categoria: modeloSelecionado.categoria
    });
  };

  const selecionarModelo = (modelo) => {
    setModeloSelecionado(modelo);
  };

  // Extrair categorias únicas dos modelos
  const categorias = [...new Set(modelos.map(modelo => modelo.categoria).filter(Boolean))];
  
  // Filtrar modelos com base no texto e categoria
  const modelosFiltrados = modelos.filter(modelo => {
    const matchTexto = modelo.nome.toLowerCase().includes(filtro.toLowerCase()) || 
                      (modelo.descricao && modelo.descricao.toLowerCase().includes(filtro.toLowerCase()));
    const matchCategoria = !categoriaFiltro || modelo.categoria === categoriaFiltro;
    return matchTexto && matchCategoria;
  });

  return (
    <div className="popup">
      <div className="medicamento-form">
        <div className="form-header">
          <h2>Adicionar Medicamento</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="modelos-section">
          <div className="section-header">
            <h3>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
              </svg>
              Selecione um Modelo de Medicamento
            </h3>
            
            <div className="filtros-container">
              <div className="filtro-input">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.3-4.3"></path>
                </svg>
                <input 
                  type="text" 
                  placeholder="Buscar medicamento..." 
                  value={filtro}
                  onChange={(e) => setFiltro(e.target.value)}
                />
              </div>
              
              {categorias.length > 0 && (
                <select 
                  value={categoriaFiltro} 
                  onChange={(e) => setCategoriaFiltro(e.target.value)}
                  className="filtro-categoria"
                >
                  <option value="">Todas categorias</option>
                  {categorias.map(cat => (
                    <option key={cat} value={cat}>{cat}</option>
                  ))}
                </select>
              )}
            </div>
          </div>
          
          {modelos.length === 0 ? (
            <div className="sem-modelos">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 8v4"></path>
                <path d="M12 16h.01"></path>
              </svg>
              <p>Você ainda não possui modelos de medicamentos cadastrados.</p>
              <p>Vá para a seção "Modelos de Medicamentos" para criar seus modelos.</p>
              <div className="botoes-sem-modelos">
                <button className="btn-secondary" onClick={onClose}>Voltar</button>
                <button className="btn-primary" onClick={() => window.location.href = '/adicionar-medicamento'}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="12" y1="8" x2="12" y2="16"></line>
                    <line x1="8" y1="12" x2="16" y2="12"></line>
                  </svg>
                  Criar Modelo
                </button>
              </div>
            </div>
          ) : modelosFiltrados.length === 0 ? (
            <div className="sem-modelos">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 8v4"></path>
                <path d="M12 16h.01"></path>
              </svg>
              <p>Nenhum medicamento encontrado com os filtros atuais.</p>
              <button className="btn-secondary" onClick={() => {setFiltro(""); setCategoriaFiltro("");}}>Limpar filtros</button>
            </div>
          ) : (
            <>
              <div className="modelos-grid">
                {modelosFiltrados.map(modelo => (
                  <div 
                    key={modelo.id} 
                    className={`modelo-card ${modeloSelecionado?.id === modelo.id ? 'selecionado' : ''}`}
                    onClick={() => selecionarModelo(modelo)}
                  >
                    <div className="modelo-header">
                      <div className="modelo-titulo">
                        <div className="modelo-nome">{modelo.nome}</div>
                        {modelo.categoria && (
                          <span className="modelo-categoria">{modelo.categoria}</span>
                        )}
                      </div>
                    </div>
                    <div className="modelo-detalhes">
                      <div className="detalhe-principal">
                        <span className="detalhe-dosagem">{modelo.dosagem}</span>
                        <span className="detalhe-frequencia">{modelo.frequencia}</span>
                      </div>
                      
                      {modelo.fabricante && (
                        <div className="detalhe">
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16"></path>
                            <path d="M1 21h22"></path>
                            <path d="M9 21v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6"></path>
                          </svg>
                          <span className="detalhe-valor">{modelo.fabricante}</span>
                        </div>
                      )}
                      
                      {modelo.viaAdministracao && (
                        <div className="detalhe">
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m12 13-2-2 2-2 2 2-2 2Z"></path>
                            <path d="M12 21.5a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19Z"></path>
                          </svg>
                          <span className="detalhe-valor">{modelo.viaAdministracao}</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              
              {modeloSelecionado && (
                <div className="modelo-detalhes-completos">
                  <h3>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                      <path d="M17 21h-10a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z"></path>
                      <path d="M9 9h1"></path>
                      <path d="M9 13h6"></path>
                      <path d="M9 17h6"></path>
                    </svg>
                    Detalhes do Medicamento Selecionado
                  </h3>
                  <div className="modelo-info">
                    <div className="info-item">
                      <span className="info-label">Nome</span>
                      <span className="info-valor">{modeloSelecionado.nome}</span>
                    </div>
                    
                    <div className="info-item">
                      <span className="info-label">Dosagem</span>
                      <span className="info-valor">{modeloSelecionado.dosagem}</span>
                    </div>
                    
                    <div className="info-item">
                      <span className="info-label">Frequência</span>
                      <span className="info-valor">{modeloSelecionado.frequencia}</span>
                    </div>
                    
                    {modeloSelecionado.fabricante && (
                      <div className="info-item">
                        <span className="info-label">Fabricante</span>
                        <span className="info-valor">{modeloSelecionado.fabricante}</span>
                      </div>
                    )}
                    
                    {modeloSelecionado.viaAdministracao && (
                      <div className="info-item">
                        <span className="info-label">Via de Administração</span>
                        <span className="info-valor">{modeloSelecionado.viaAdministracao}</span>
                      </div>
                    )}

                    {modeloSelecionado.categoria && (
                      <div className="info-item">
                        <span className="info-label">Categoria</span>
                        <span className="info-valor">{modeloSelecionado.categoria}</span>
                      </div>
                    )}
                    
                    {modeloSelecionado.descricao && (
                      <div className="info-item descricao">
                        <span className="info-label">Descrição</span>
                        <span className="info-valor">{modeloSelecionado.descricao}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        
        <div className="form-buttons">
          <button 
            className="save-btn" 
            onClick={handleSubmit}
            disabled={!modeloSelecionado}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
              <polyline points="17 21 17 13 7 13 7 21"></polyline>
              <polyline points="7 3 7 8 15 8"></polyline>
            </svg>
            Adicionar Medicamento
          </button>
          <button className="cancel-btn" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default MedicationForm;